import React from 'react';
import MyTeams from '@components/MarketWorking/MyTeam/MyTeams';
import { VisitDetails, MyDiary, MySR } from '@shared/components';
import PageLayout from '@features/shared/components/PageLayout';
import { usePageInitialization } from '@features/shared/hooks/usePageInitialization';

/**
 * MyTeam Page - Team visit details, hierarchy, diary, and SR reports
 */
const MyTeamPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Market Working" backPath="/">
      <VisitDetails />
      <MyTeams />
      <MyDiary />
      <MySR />
    </PageLayout>
  );
};

export { MyTeamPage };
export default MyTeamPage;
